import React from 'react';
import {
  axisClasses,
  barElementClasses,
  BarPlot,
  ChartsTooltip,
  ChartsXAxis,
  ChartsYAxis,
  ResponsiveChartContainer
} from "@mui/x-charts";
import {
  DashboardAtrasoPorSistemaFields,
  DashboardPromedioResolucion,
  DashboardPromedioResolucionFields
} from "../types/dashboard";
import {useTheme} from "@mui/material";
import CardActions from "../../sistema/components/CardActions";
import {hexToRGBA} from "../../../@core/utils/hex-to-rgba";

interface AtrasoPorSistemaChartProps {
  data: DashboardPromedioResolucion[];
}

function PromedioResolucionPorSistemaChart({data}: AtrasoPorSistemaChartProps) {
  const theme = useTheme();

  const aprobadasData = data
    .filter(item => item[DashboardPromedioResolucionFields.Etapa] === 'Aprobadas')
    .map(item => item[DashboardPromedioResolucionFields.AtrasoPromedioDias]);

  const rechazadasData = data
    .filter(item => item[DashboardPromedioResolucionFields.Etapa] === 'Rechazadas')
    .map(item => item[DashboardPromedioResolucionFields.AtrasoPromedioDias]);

  const xLabels = data
    .filter((item, index, self) => self.findIndex(t => t[DashboardPromedioResolucionFields.Sistema] === item[DashboardPromedioResolucionFields.Sistema]) === index)
    .map(item => item[DashboardPromedioResolucionFields.Sistema]);

  return (
    <CardActions title={'Promedio Resolución'} colapsable>
      <ResponsiveChartContainer
        height={400}
        series={[
          {
            type: 'bar',
            data: aprobadasData,
            label: 'Tiempo Resolución Aprobadas (días)',
            id: 'aprobadas',
            yAxisId: 'cantMensajes',
          },
          {
            type: 'bar',
            data: rechazadasData,
            label: 'Tiempo Resolución Rechazadas (días)',
            id: 'rechazadas',
            yAxisId: 'cantMensajes',
            color: theme.palette.primary.main,
          },
        ]}
        xAxis={[
          {
            data: xLabels,
            scaleType: 'band',
            id: 'x-axis-id',
            valueFormatter: (sistema, context) =>
              context.location === 'tick'
                ? `${data.find((d) => d[DashboardAtrasoPorSistemaFields.Sistema] === sistema)?.[DashboardAtrasoPorSistemaFields.Abreviacion]}`
                : `Workflow: ${data.find((d) => d[DashboardAtrasoPorSistemaFields.Sistema] === sistema)?.[DashboardAtrasoPorSistemaFields.Abreviacion]} (${sistema})`,
          },
        ]}
        margin={{left: 70, right: 70}}
        sx={{
          [`.${axisClasses.left} .${axisClasses.label}`]: {
            transform: 'translate(-25px, 0)',
          },
          [`.${axisClasses.right} .${axisClasses.label}`]: {
            transform: 'translate(30px, 0)',
          },
          [`.${barElementClasses.root}`]: {
            fill: hexToRGBA(theme.palette.primary.main, 0.08),
            stroke: hexToRGBA(theme.palette.primary.main, 0.75),
            strokeWidth: 1,
            clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 1px), 0 calc(100% - 1px))' // Magia para eliminar el borde inferior
          },
        }}
        yAxis={[
          {
            id: 'cantMensajes',
          },
        ]}
      >
        <BarPlot/>
        <ChartsTooltip/>

        <ChartsYAxis axisId="cantMensajes" label="Tiempo Resolución (días)"/>
        <ChartsXAxis label="Sistemas" position="bottom" axisId="x-axis-id"/>
      </ResponsiveChartContainer>
    </CardActions>

  );
}

export default PromedioResolucionPorSistemaChart;